var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIniciarSesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "472pt",
    viewBox: "-3 0 471 472",
    width: "472pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m294.101562 456-21.601562-72h-80l-21.601562 72h-26.398438v16h176v-16zm0 0",
    fill: "#e0e0de"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m279.699219 408-7.199219-24h-80l-7.199219 24zm0 0",
    fill: "#d6d6d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5 64c-13.253906 0-24 10.746094-24 24v248h464v-248c0-13.253906-10.746094-24-24-24zm0 0",
    fill: "#348fd9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m.5 320h464v16h-464zm0 0",
    fill: "#3086cd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m.5 336v24c0 13.253906 10.746094 24 24 24h416c13.253906 0 24-10.746094 24-24v-24zm0 0",
    fill: "#e0e0de"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m392.5 0h-320c-13.253906 0-24 10.746094-24 24v312h368v-312c0-13.253906-10.746094-24-24-24zm0 0",
    fill: "#60d1e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m88.5 336h328v-312c-.015625-5.375-1.859375-10.585938-5.222656-14.777344zm0 0",
    fill: "#5ac6d4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m72.5 24h16v16h-16zm0 0",
    fill: "#3a9cc9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m104.5 24h16v16h-16zm0 0",
    fill: "#3a9cc9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m136.5 24h16v16h-16zm0 0",
    fill: "#3a9cc9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m136.5 224h192c17.671875 0 32 14.328125 32 32s-14.328125 32-32 32h-192c-17.671875 0-32-14.328125-32-32s14.328125-32 32-32zm0 0",
    fill: "#e0e0de"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3a9cc9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m224.5 248h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.5 248h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.5 248h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.5 248h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.5 248h16v16h-16zm0 0"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m296.5 128c0 35.347656-28.652344 64-64 64s-64-28.652344-64-64 28.652344-64 64-64 64 28.652344 64 64zm0 0",
    fill: "#348fd9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m256.5 120c0 13.253906-10.746094 24-24 24s-24-10.746094-24-24 10.746094-24 24-24 24 10.746094 24 24zm0 0",
    fill: "#fec9a3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m276.964844 173.96875c-7.355469-18.089844-24.9375-29.917969-44.464844-29.917969s-37.109375 11.828125-44.464844 29.917969c24.769532 24.039062 64.160156 24.039062 88.929688 0zm0 0",
    fill: "#e94f4f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m48.5 320h368v16h-368zm0 0",
    fill: "#5ac6d4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m403.1875 328.214844c-4.648438-.792969-9.410156.507812-13.011719 3.550781-3.601562 3.042969-5.679687 7.519531-5.675781 12.234375 0-8.835938-7.164062-16-16-16s-16 7.164062-16 16c0-8.835938-7.164062-16-16-16s-16 7.164062-16 16v-72c.179688-8.039062-5.429688-15.050781-13.3125-16.640625-4.648438-.792969-9.410156.507813-13.011719 3.550781-3.601562 3.042969-5.679687 7.519532-5.675781 12.234375v120.855469l-33.351562-20c-4.144532-2.496094-9.277344-2.695312-13.601563-.527344l-1.253906.632813c-4.777344 2.394531-7.792969 7.277343-7.792969 12.621093-.003906 4.5625 2.199219 8.847657 5.910156 11.496094l50.089844 35.777344h128v-87.144531c.179688-8.039063-5.429688-15.046875-13.3125-16.640625zm0 0",
    fill: "#fec9a3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m416.5 64h16v272h-16zm0 0",
    fill: "#3086cd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m416.5 336h16v48h-16zm0 0",
    fill: "#d6d6d4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m406.101562 328.992188c-31.203124 58.273437-85.152343 87.113281-121.121093 100.496093l3.519531 2.511719h128v-87.144531c.09375-6.914063-4.019531-13.191407-10.398438-15.863281zm0 0",
    fill: "#fec093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIniciarSesion);
export default __webpack_public_path__ + "static/media/iniciar-sesion.9f059bb5a4a5ac1b3b16c48da4d1d19c.svg";
export { ForwardRef as ReactComponent };